import { Controller, UseFormReturn } from 'react-hook-form';
import { ConfigurationFormData } from '../../types';
import Dropdown from '@cp/src/components/Dropdown';
import styles from '../index.module.scss';
import { SelectPickerOptionProps } from '@cp/src/types/CommonConstans';
import { DropdownValue } from './interface';

interface DropdownFieldProps {
  control: UseFormReturn<ConfigurationFormData>['control'];
  errors: UseFormReturn<ConfigurationFormData>['formState']['errors'];
  fieldName: keyof ConfigurationFormData;
  label: string;
  mandatory: boolean;
  options: Array<SelectPickerOptionProps> | undefined;
  isMultiSelect: boolean;
  transformedOptions: Array<SelectPickerOptionProps> | undefined;
  placeholder?: string;
}

const DropdownField = (props: DropdownFieldProps) => {
  const {
    control,
    errors,
    fieldName,
    label,
    mandatory,
    isMultiSelect,
    transformedOptions,
    placeholder
  } = props;

  const handleMultiSelectChange = (
    selectedValues: SelectPickerOptionProps[]
  ): SelectPickerOptionProps[] => {
    return Array.isArray(selectedValues) ? selectedValues : [];
  };

  const handleSingleSelectChange = (selectedOption: SelectPickerOptionProps): string | number => {
    return selectedOption.value;
  };

  const handleSelectionChange = (
    selectedValue: SelectPickerOptionProps | SelectPickerOptionProps[],
    onChange: (value: any) => void
  ) => {
    onChange(
      isMultiSelect
        ? handleMultiSelectChange(selectedValue as SelectPickerOptionProps[])
        : handleSingleSelectChange(selectedValue as SelectPickerOptionProps)
    );
  };

  const getSelectedValue = (value: DropdownValue): DropdownValue => {
    if (!isMultiSelect) return value || undefined;
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  return (
    <Controller
      control={control}
      name={fieldName}
      rules={mandatory ? { required: `Please select ${label}` } : {}}
      render={({ field: { onChange, value } }) => (
        <Dropdown
          placeholder={placeholder || `Select ${label}`}
          placeholderColor="var(--navi-color-gray-c3)"
          showSolidArrow={true}
          arrowIconWidth={9}
          options={transformedOptions}
          multiSelect={isMultiSelect}
          onSelectionChange={(
            selectedValue: SelectPickerOptionProps | SelectPickerOptionProps[]
          ) => {
            handleSelectionChange(selectedValue, onChange);
          }}
          showEllipsisTooltip={true}
          selectedValue={getSelectedValue(value)}
          containerClasses={styles.dropdownContainer}
          error={errors[fieldName]?.message}
          pickerContainerClasses="max-h-[266px]"
          showTextCursorOnDisabled={true}
          tabIndexEnabled={true}
        />
      )}
    />
  );
};

export default DropdownField;
